module.exports = __webpack_public_path__ + "img/graphqlapi.11094ebf.svg";